import _ from 'lodash';
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert, Button, Col, Row } from 'reactstrap';
import { CustomerTypeahead, ProspectTypeAhead, SalesCallTrackingGrid } from '.';
import { SpinnerButton } from './';
import { DesktopContainer } from "../layouts";
import { api, constants, filterHelpers, helpers, UserContext } from "../utils";
import moment from "moment";
import DatePicker from "react-datepicker";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

export default function SalesCallTracking(props) {
  const userCtx = useContext(UserContext);
  const navigate = useNavigate();
  const finalStartDate = moment().add(-13, "years");
  const defaultPageSize = 25;
  const pageSize = defaultPageSize;
  const [customer, setCustomer] = useState(null)
  const [initialized, setIntialized] = useState(false);
  const [loaded, setloaded] = useState(false);
  const [message, setMessage] = useState(null);
  const [page, setPage] = useState(1);
  const [prospect, setProspect] = useState(null)
  const [running, setRunning] = useState(false);
  const [salesCallTrackingData, setSalesCallTrackingData] = useState([]);
  const [salespeopleList, setSalespeopleList] = useState(null);
  const [salesperson, setSalesperson] = useState();
  const [salesTrackingAction, setSalesTrackingAction] = useState(null)
  const [salesTrackingActionTypes, setSalesTrackingActionTypes] = useState([]);
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState("TrackingId")
  const [totalPages, setTotalPages] = useState(0);
  const [filters, setFilters] = useState([
    { filterName: "startDate", value: finalStartDate.toDate() },
    { filterName: "endDate", value: null }
  ]);

  useEffect(() => {
    document.title = `Sales Call Tracking`
    if (userCtx && !initialized) {
      if (userCtx.customerFilter) {
        userCtx.setCustomerFilter(null);
        setIntialized(true);
        //refreshData();
      }
    }

    let apiCalls = [];
    apiCalls.push(
      api.fetch(`Reference/GetSalespeopleList`).then((response) => {
        return {
          salespeople: response.data.salespeople
        };
      })
        .catch(api.catchHandler)
    );
    apiCalls.push(
      api.fetch(`Reference/GetAllSalesTrackingActionTypes`).then((response) => {
        return {
          salesTrackingActionTypes: response.data.salesTrackingActionTypes
        };
      })
        .catch(api.catchHandler)
    );
    apiCalls.push(
      api.fetch(`Reference/GetItemClasses`).then((response) => {
        return {
          itemClasses: _.map(response.data.itemClasses, (x) => {
            return x.itemClass
          })
        };
      })
        .catch(api.catchHandler)
    );

    Promise.all(apiCalls).then(arrayResults => {
      let aggResults = {};
      _.each(arrayResults, (x) => Object.assign(aggResults, x));
      setSalespeopleList(
        _.chain(aggResults.salespeople)
          .map((sp) => {
            return {
              value: sp.salespersonId,
              label: sp.salespersonText,
            };
          })
          .sortBy((x) => {
            return x.label;
          })
          .unshift({
            value: 'All',
            label: '--- All ---'
          })
          .value()
      );
      setSalesTrackingActionTypes(
        _.chain(aggResults.salesTrackingActionTypes)
          .map((a) => {
            return {
              value: a.actionTypeId,
              label: a.description,
            };
          })
          .sortBy((x) => {
            return x.label;
          })
          .value()
      );
    }).catch(error => setMessage({ flavor: "alert-danger", text: "There was an error loading sales people data" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { runQuery(); }, [page])

  function createPayload() {
    let payload = {
      // SortField: sortField,
      SalesPersonId: "",
      SortField: "TrackingId",
      SortDirection: "null",
      PageNumber: page,
      PageSize: pageSize
    };
    _.map(filters, (filter) => { payload[filter.filterName] = filter.value; });
    if (payload.startDate === "") {
      payload.startDate = null;
    }
    if (payload.endDate === "") {
      payload.endDate = currentDate();
    }
    // payload.actionTypeId = salesTrackingAction.value;
    payload.SalesPersonId = salesperson.value;
    return payload;

  }

  function currentDate() {
    let date = new Date();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }

  function onDelete(callId) {
    confirmAlert({
      title: "Confirm Deletion",
      message: 'Are you sure you\'d like to permanently delete this sales call?',
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            api.fetch("Order/DeleteSalesCall/" + callId).then(r => {
              if (r.data.success) {
                setSalesCallTrackingData(
                  _.reject(salesCallTrackingData, x => x.trackingId === callId)
                );
              } else {
                setMessage({
                  flavor: "alert-warning",
                  text: r.data.message
                });
              }
            })
              .catch(api.catchHandler);
          }
        },
        {
          label: "No"
        }
      ]
    });
  }

  function onFilterChange(changedFilter) {
    setPage(1);
    const filterChanges = filterHelpers.getFilters(filters, changedFilter);
    setFilters(filterChanges);
    setloaded(false)
  }

  function onSortChange(field, direction) {
    if (field !== sortField) {
      setSortField(field);
      setSortDirection("asc")
    } else {
      setSortDirection(direction);
    }
    setPage(1);
  }

  function printSalesCall(trackingId) {
    let payload = trackingId ? { trackingId: trackingId } : createPayload()
    setRunning(true);
    api
      .postDownloadBinary("Report/SalesCallReport", payload, constants.MIME_TYPES.pdf, `SalesCallReport_${currentDate()}.pdf`)
      .then((res) => {
        if (res?.data === false) {
          toast.error(res.message);
        }
      })
      .catch(api.catchHandler)
      .finally(() => setRunning(false));
  }

  function runQuery() {
    let warnings = [];
    // if (!customerId || !customerId.value || !prospect || !prospect.value) {
    //    warnings.push("A Customer or prospect is required.");
    //  }
    if (!salesperson || !salesperson.value) {
      warnings.push("Salesperson is required.");
    }
    if (!salesTrackingAction || !salesTrackingAction.value) {
      warnings.push("Contact type is required.");
    }

    if (warnings.length) {
      setMessage({
        text: warnings.join(" "),
        flavor: "danger",
      });
      return;
    } else {
      setMessage(null);
    }
    setRunning(true);
    api
      .post(`Sales/SalesCallTrackingSearch`, createPayload())
      .then(response => {
        if (response.data.success) {
          setSalesCallTrackingData(response.data.message.items);
          setTotalPages(_.ceil(response.data.message.totalCount / pageSize));
        }
      })
      .catch(api.catchHandler)
      .finally(() => {
         setloaded(true);
         setRunning(false);
      })
  }

  return (
    <DesktopContainer screenName="Sales Call Tracking">
      <div className="filter-header">
        <Row style={{ padding: "10px" }}>
          <Col xs={{ span: 3, offset: 4 }}>
            <Button
              size="sm"
              className="shredButton"
              onClick={() => navigate(constants.ENDPOINTS.salesCallTrackingEdit + '/0')}>
              Add New Sales Call
            </Button>
          </Col>
        </Row>
        < Row className="justify-content-center mb-2">
          <Col xs="3" lg="2" className="text-end" style={{ display: "flex", justifyContent: "flex-end" }}>
            <h4
              className="pt-1 text-white"
              children="Sales Person:"
            />{!salesperson ? helpers.requiredStar2() : null}
          </Col>
          <Col xs="6">
            <Select
              classNamePrefix="serviceThreadSelect"
              filterName="SalesPersonId"
              options={salespeopleList}
              value={salesperson}
              onChange={(e) => {
                 setPage(1);
                 setSalesperson(e);
                 }}
              isClearable
            />
          </Col>
        </Row>
        <Row className="align-items-center my-1">
          <Col xs="4" className="text-end" style={{ display: "flex", justifyContent: "flex-end" }}>
            <h4
              className="pt-1 text-white"
              children="Customers:"
            />
          </Col>
          <Col xs={6}>
            <CustomerTypeahead
              value={customer}
              onChange={(c) => {
                setCustomer(c);
                if (c) {
                  onFilterChange({
                    filterName: "customerId",
                    value: c.value,
                    filteredDisplay: `Customer: ${c.label}`
                  });
                } else {
                  setFilters(
                    _.reject(filters, (x) => x.filterName === "customerId"));
                }
              }}
            />
          </Col>
        </Row>
        <Row className="align-items-center my-1">
          <Col xs="4" style={{ display: "flex", justifyContent: "flex-end" }}>
            <h4
              className="pt-1 text-white"
              children="Prospects:"
            />
          </Col>
          <Col xs={6}>
            <ProspectTypeAhead
              value={prospect}
              onChange={(c) => {
                setProspect(c);
                if (c) {
                  onFilterChange({
                    filterName: "contactOther",
                    value: c.value,
                    filteredDisplay: `Prospect: ${c.label}`
                  });
                } else {
                  setFilters(
                    _.reject(filters, (x) => x.filterName === "contactOther"));
                }
              }}
            />
          </Col>
        </Row>
        <Row className="align-items-center my-1">
          <Col xs="4" className="text-end" style={{ display: "flex", justifyContent: "flex-end" }}>
            <h4
              className="pt-1 text-white"
              children="Contact Type:"
            />{!salesTrackingAction ? helpers.requiredStar2() : null}
          </Col>
          <Col xs={6}>
            <Select
              classNamePrefix="serviceThreadSelect"
              closeMenuOnSelect={true}
              components={makeAnimated()}
              options={salesTrackingActionTypes}
              onChange={(c) => {
                setSalesTrackingAction(c);
                if (c) {
                  onFilterChange({
                    filterName: "actionType",
                    value: c.value,
                    filteredDisplay: `call type: ${c.label}`
                  });
                } else {
                  setFilters(
                    _.reject(filters, (x) => x.filterName === "actionType"));
                }
              }}
              value={salesTrackingAction}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
            <h4
              className="pt-1 text-white"
              children="Start Date:"
            />
          </Col>
          <Col xs={3}>
            <DatePicker
              className="form-control"
              selected={filterHelpers.getValue(filters, "startDate")}
              onChange={(newValue) =>
                setFilters(
                  filterHelpers.getFilters(filters, {
                    filterName: "startDate",
                    value: newValue,
                    filteredDisplay: `Start Date: ${newValue}`
                  }))
              }
              dateFormat="yyyy-MM-dd"
              placeholderText="Select a date"
            />
          </Col>
        </Row>
        <Row className="mt-1">
          <Col xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
            <h4
              className="pt-1 text-white"
              children="End Date:"
            />
          </Col>
          <Col xs={3}>
            <DatePicker
              className="form-control"
              selected={filterHelpers.getValue(filters, "endDate")}
              onChange={(newValue) =>
                setFilters(
                  filterHelpers.getFilters(filters, {
                    filterName: "endDate",
                    value: newValue,
                    filteredDisplay: `End Date: ${newValue}`
                  }))
              }
              dateFormat="yyyy-MM-dd"
              placeholderText="Select a date"
            />
          </Col>
        </Row>
        <Row style={{ padding: "10px" }}>
          <Col xs={{ span: 3, offset: 4 }}>
            <SpinnerButton
              size="sm"
              className="shredButton"
              onClick={runQuery}
              on={running}
              disabled={running}
            >
              Show Results
            </SpinnerButton>
            <SpinnerButton
              style={{ marginLeft: "20px" }}
              size="sm"
              className="shredButton"
              onClick={() => printSalesCall()}
              on={running}
              disabled={running}
            >
              Print Report
            </SpinnerButton>
          </Col>
        </Row>
      </div>
      <div style={{ paddingTop: "20px" }}>
        {message ? (
          <Alert className={message.flavor}>{message.text}</Alert>
        ) : null}
        {loaded === true ?
          <SalesCallTrackingGrid
            salesCallTrackingData={salesCallTrackingData}
            printFunction={printSalesCall}
            displayOnlyId={true}
            onDelete={onDelete}
            defaultPageSize={defaultPageSize}
            sortCallback={onSortChange}
            sortField={sortField}
            sortDirection={sortDirection}
            pagerCallback={(page) => setPage(page)}
            pageNumber={page}
            totalPages={totalPages}
            pageSize={pageSize}
          /> : null}
      </div>
    </DesktopContainer>
  )
}
